'use strict';

angular.module('atex.art').controller('ArtContentAutoSaveCtrl',
['$scope','$q', '$timeout', 'ArtContentStore', 'ArtTemplateStore', 'ArtCommonServices','$location','$routeParams','articles', 'templates',
  function($scope, $q, $timeout, ArtContentStore, ArtTemplateStore, ArtCommonServices, $location, $routeParams, articles, templates) {
    var id = $routeParams.id;

    var objects = articles.filter(function (article) {
      return (!article.local.persisted && !article.isBeingSent && !article.local.conflict && article.meta.id === id );
    });

    if(objects.length > 0) {
      objects.forEach(function(object) {
        delete object.data.contentUpdated;

        if(object.local.valid) {
          ArtCommonServices.storeToServer(object,templates).then(function(stored) {
            if(stored) {
              ArtCommonServices.unlockResources(object).then(function () {
                ArtCommonServices.unlockArticle(object).then(function () {
                  $timeout(function () {
                    ArtCommonServices.close();
                  }, 2500);
                });
              });
            } else {
              $location.path('/');
            }
          });
        } else {
          $location.path('/');
        }
      });
    }

  }
]);

var ContentAutoSaveController = {
  resolves : {
    'preload-factory' : function(PreloadService) {
      return PreloadService.preloadFactoryList('actList');
    },
    'articles': function(ArtContentStore) {
      return ArtContentStore.getAll();
    },

    'templates': function(ArtTemplateStore) {
      return ArtTemplateStore.getAll();
    }
  }
};